import axios from "axios";

export function apiListInstances(email, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS + "api/instances" + (queryParams ? "?" + queryParams : ""),
      {
        params: {
          email: email,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetInstance(id, email) {
  return axios
    .get(process.env.REACT_APP_URL_EXPRESS + "api/instances/" + id, {
      params: {
        email: email,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiUpdateInstance(id, formData) {
  return axios
    .put(process.env.REACT_APP_URL_EXPRESS + "api/instances/" + id, formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
